// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file common/sensitivity.proto (package lvdr.v2.common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file common/sensitivity.proto.
 */
export const file_common_sensitivity: GenFile = /*@__PURE__*/
  fileDesc("Chhjb21tb24vc2Vuc2l0aXZpdHkucHJvdG8SDmx2ZHIudjIuY29tbW9uKlcKC1NlbnNpdGl2aXR5EhYKElNFTlNJVElWSVRZX1BVQkxJQxAAEhgKFFNFTlNJVElWSVRZX0lOVEVSTkFMEAESFgoSU0VOU0lUSVZJVFlfU0VDUkVUEAJCJ1olZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL2NvbW1vbmIGcHJvdG8z");

/**
 * Sensitivity gates whether a record can be included in outbound LLM
 * contexts that cross the trust boundary into external services
 * (currently: ElevenLabs voice).
 *
 * PUBLIC = OK to include in outbound LLM context (default for crawled web).
 * INTERNAL = included, but flowed through OutboundGuard regex on the way out.
 * SECRET = never reaches the LLM endpoint at all.
 *
 * Zero-value is PUBLIC so unset fields on crawled-content records are
 * already safe. New user-generated records default to INTERNAL at the
 * storage layer (not in the proto default).
 *
 * NOTE: This enum is called "Sensitivity" (not "Classification") to avoid
 * colliding with the Palace wing/hall/room "classification" concept already
 * used throughout the knowledge subsystem.
 *
 * @generated from enum lvdr.v2.common.Sensitivity
 */
export enum Sensitivity {
  /**
   * @generated from enum value: SENSITIVITY_PUBLIC = 0;
   */
  PUBLIC = 0,

  /**
   * @generated from enum value: SENSITIVITY_INTERNAL = 1;
   */
  INTERNAL = 1,

  /**
   * @generated from enum value: SENSITIVITY_SECRET = 2;
   */
  SECRET = 2,
}

/**
 * Describes the enum lvdr.v2.common.Sensitivity.
 */
export const SensitivitySchema: GenEnum<Sensitivity> = /*@__PURE__*/
  enumDesc(file_common_sensitivity, 0);

